import styled from "styled-components";
import {Box, Card, Heading, Button, Flex} from "rebass";
import {CheckCircle, MapMarkerAlt} from "styled-icons/fa-solid";
import {Overlay} from "reakit";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import { backgroundColor } from "styled-system";

export const PanelWrapper = styled(Card)`
//min-width: 250px;
//	height: calc(100vh - 131px);
//	margin-bottom: 10px;
	max-height: calc(45vh - 65px);
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  //@media(max-width: 700px){
  //	height: 70vh;
  //
  //}
`;

/* icon imports */
export const SidebarWrapper = styled(Card)`
min-width: 260px;
	height: calc(100vh - 131px);
	margin-bottom: 10px;
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	height: calc(100vh - 194px);

  }
`;

export const SidebarBox = styled(Box)`
min-width: 260px;

`


export const Check = styled(CheckCircle)`
  width: 20px;
  height: 20px;
  color: white;
`;

export const MapMarker = styled(MapMarkerAlt)`
  width: 20px;
  height: 20px;
  color: white;
`;



export const FilterOverlay = styled(Overlay)`
width: 50%;
height: auto;
	@media(max-width: 700px){
	width: 100%;
height: 100%;
	}
`;

export const Arrow = styled(IosArrowForward)`
 //margin-top: 10px;
`

export const HeaderWrapper = styled(Card)`
position: relative;
top: 0;
left: 0;
width: 100vw;
min-height: 140px;
max-height: 140px;
`

HeaderWrapper.defaultProps = {
	p: [2],
	boxShadow: 'main'
};

export const Title = styled(Heading)`
margin-top: 0px;
margin-left: 7px;
`

export const CircleButton = styled(Button)`
  margin: 0 0 0 6px;
  padding: 2px;
  border-radius: 50%;
  background-color: #ffc61a;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ease-in-out transform 0.3s;
  flex-shrink: 0;
  ${({ active }) => active && `
    transform: rotate(135deg);
  `}
`

export const ActionButton = styled(Button)`
  margin: 0 0 0 6px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 12px;
  ${backgroundColor}
  transition: ease-in-out transform 0.2s;
  &:nth-child(1) {
    transform: scale(0);
    transition-delay: 0.21s;
    ${({ active }) => active && `
      transform: scale(1);
      transition-delay: 0.03s;
    `}
  }
  &:nth-child(2) {
    transform: scale(0);
    transition-delay: 0.15s;
    ${({ active }) => active && `
      transform: scale(1);
      transition-delay: 0.09s;
    `}
  }
  &:nth-child(3) {
    transform: scale(0);
    transition-delay: 0.09s;
    ${({ active }) => active && `
      transform: scale(1);
      transition-delay: 0.15s;
    `}
  }
`

export const FlexWrapper = styled(Flex)`
  width: 30px;
  overflow: hidden;
  ${({ active }) => active && `
    width: auto;
  `}
`